import { collection, orderBy, query } from 'firebase/firestore'
import { db } from '../firebase/firebase'
import { createSlice } from '@reduxjs/toolkit'
import { createFetchThunk } from '../store/fetch'

const q = query(collection(db, 'auditData'), orderBy('name', 'asc'))
const access = ['superadmin', 'admin', 'operator', 'developer']

export const fetchAuditData = createFetchThunk('auditData', q, access)

const auditDataSlice = createSlice({
  name: 'auditData',
  initialState: {
    data: [],
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
    filters: {
      searchTerm: '',
      sort: {
        key: 'name',
        direction: 'asc',
      },
    },
  },
  reducers: {
    auditDataAdded: (state, action) => {
      state.data.push(action.payload)
    },
    auditDataUpdated: (state, action) => {
      const index = state.data.findIndex((auditData) => auditData.id === action.payload.id)
      if (index !== -1) {
        state.data[index] = action.payload
      }
    },
    allAuditDataUpdated: (state, action) => {
      state.data = action.payload
    },
    setFilters: (state, action) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAuditData.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchAuditData.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload
      })
      .addCase(fetchAuditData.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message
      })
  },
})

export const { auditDataAdded, auditDataUpdated, allAuditDataUpdated, setFilters } =
  auditDataSlice.actions
export default auditDataSlice.reducer
